import { createAction } from 'redux-actions';
import { authFetch } from '../AuthFetch';

export const changeWashLabelValue = createAction('CHANGE_WASHLABEL_VALUE');

export const cleanWashLabelAlert = createAction('CLEAN_WASHLABEL_ALERT');

export const generateWashLabel = (washLabel) => (
  (dispatch) => {

    dispatch({
      type: 'BEFORE_GENERATE_WASHLABEL'
    });

    let url = '/firefighter/washlabel/generate';
    authFetch('POST', url, JSON.stringify(washLabel), (json) => {
      dispatch({
        type: 'AFTER_GENERATE_WASHLABEL',
        payload: json
      });
    });
  }
);


// WEBPACK FOOTER //
// ./src/actions/washLabelActions.js